import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import useCurrentUserId from './useCurrentUserId';

const useAllRUPIdsByPalette = (paletteId: string | undefined) : string[] => {
  const userId = useCurrentUserId();
  const rupDb = useSelector((state: RootState) => state.relationUserPaletteDb);
  const ids = Object.keys(rupDb.relationUserPalettes).filter(id => {
    return rupDb.relationUserPalettes[id].paletteId === paletteId && rupDb.relationUserPalettes[id].userId === userId;
  });

  return ids;
}

export default useAllRUPIdsByPalette;
